import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { HeaderState } from "../types";

// Initial state
const initialState: HeaderState = {
  languagesData: {
    isLoading: false,
    isError: false,
    error: '',
    data: [],
  },
  currentLanguage: {
    label: 'English',
    code: 'en',
    direction: 'ltr',
  },
};

// Helper function to get error message
const getErrorMessage = (message?: string) => {
  return message || "An error occurred";
};

// Async thunk for fetching languages
export const fetchLanguages = createAsyncThunk(
  "header/language/get",
  async (_, { extra }: any) => {
    if (!extra?.apiClient?.getV1Languages) {
      throw new Error("API client not configured for header slice");
    }
    
    const response = await extra.apiClient.getV1Languages({
      order: `id:1`,
    });
    
    const data = response?.data?.languages || [];
    const languages = data?.filter((d: any) => d?.is_active)?.map((d: any) => {
      return {
        label: d?.name,
        code: d?.code,
        direction: d?.direction
      };
    });
    
    return { languages };
  }
);

export const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setLanguages(state, { payload }) {
      state.languagesData = { ...state.languagesData, ...payload };
    },
    setCurrentLanguage(state, { payload }) {
      state.currentLanguage = { ...state.currentLanguage, ...payload };
    },
    setLanguagesData(state, { payload }) {
      state.languagesData = payload;
    },
    resetLanguagesState(state) {
      state.languagesData = initialState.languagesData;
    },
    resetHeaderState(state) {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    /*-------------------------------- GET LANGUAGES ---------------------------------*/
    builder.addCase(fetchLanguages.pending, (state) => {
      state.languagesData = {
        isLoading: true,
        isError: false,
        error: '',
        data: [],
      };
    }).addCase(fetchLanguages.fulfilled, (state, { payload }) => {
      state.languagesData = {
        isLoading: false,
        isError: false,
        error: '',
        data: payload.languages || [],
      };
    }).addCase(fetchLanguages.rejected, (state, { error }) => {
      const m = getErrorMessage(error.message);
      state.languagesData = {
        isLoading: false,
        isError: true,
        error: m,
        data: [],
      };
    });
  },
});

export const { 
  setLanguages, 
  setCurrentLanguage, 
  setLanguagesData, 
  resetLanguagesState, 
  resetHeaderState 
} = headerSlice.actions;

export default headerSlice.reducer;